"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var GeneralSettings_1 = require("../../../../constants/GeneralSettings");
var loginSlice_1 = require("../../../../features/login/loginSlice");
var Routes_1 = require("../../../../constants/Routes");
var classnames_1 = __importDefault(require("classnames"));
var Links = function (_a) {
    var onClose = _a.onClose;
    var dispatch = react_redux_1.useDispatch();
    var history = react_router_dom_1.useHistory();
    var t = react_i18next_1.useTranslation('common').t;
    // TODO possibly can be more items here
    var links = react_1.useMemo(function () {
        return [GeneralSettings_1.PROFILE_LINKS.find(function (item) { return item.key === 'logout'; })];
    }, []);
    var handleLogOut = function (event) {
        event.preventDefault();
        dispatch(loginSlice_1.logout());
        onClose();
        history.push(Routes_1.Routes.Home.path);
    };
    return (react_1.default.createElement("ul", null, links.map(function (link, index) { return (react_1.default.createElement("li", { key: index },
        react_1.default.createElement(react_router_dom_1.Link, { to: '/', onClick: function (event) { return handleLogOut(event); } },
            react_1.default.createElement("i", { className: classnames_1.default('cm-icon', link.icon) }),
            t(link.title)))); })));
};
exports.default = react_1.memo(Links);
